import React from 'react';
import ProductListingPage from '../components/ProductListingPage';
import wholesaleProducts from '../data/wholesaleProducts';
import { useNavigate } from 'react-router-dom';

const wholesaleCategories = ['All', 'Red Chillies', 'Turmeric', 'Saffron', 'Cardamom', 'Ginger', 'Seeds & Spices'];

const WholesaleProductsPage = () => {
  const navigate = useNavigate();

  return (
    <ProductListingPage
      title="WHOLESALE"
      subtitle="PRODUCTS"
      products={wholesaleProducts}
      categories={wholesaleCategories}
      titleColor="#FFFFFF"
      backButtonPosition="right"
      contentTopPadding={{ xs: 1, md: 2 }}
      backButtonMarginBottom={1}
      headerInline
      onProductClick={(product) => navigate(`/products/wholesale/${product.id}`)}
    />
  );
};

export default WholesaleProductsPage;